import _ from 'lodash';
import GlobalAttributes from 'constants/GlobalAttributes';
import SupportedEventNames from 'constants/SupportedEventNames';

const TEXTAREA_ATTRIBUTES = [
  'autoComplete',
  'autoFocus',
  'cols',
  'disabled',
  'maxLength',
  'minLength',
  'name',
  'placeholder',
  'readOnly',
  'required',
  'rows',
  'spellCheck',
  'wrap',
];

const ALLOWED_PROPS = _.union(GlobalAttributes, SupportedEventNames, TEXTAREA_ATTRIBUTES);

export default function pickTextareaElementProps(props: { [key: string]: any }) {
  return _.pick(props, ALLOWED_PROPS);
}
